import { render, staticRenderFns } from "./VelocityGroup.vue?vue&type=template&id=496fc5cc"
import script from "./VelocityGroup.vue?vue&type=script&lang=js"
export * from "./VelocityGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports